<template>
  <section class="entry-multi-tab">
    <!-- 左侧 - 全部菜单 -->
    <div class="entry-multi-tab__menus">
      <icon-font
        type="gb-icon-appstore"
        style="font-size:14px;cursor:pointer"
        @click="visible = true"
      />

      <div class="entry-multi-tab__menus__wrapper" v-show="visible">
        <div class="entry-multi-tab__menus__wrapper__main">
          <div class="entry-menus-wrapper">
            <div class="entry-menus-wrapper__hd">
              <icon-font type="gb-icon-appstore" style="margin-right:8px;" />
              <span>{{ $t('layouts.allmenu') }}</span>
              <icon-font type="gb-icon-guanbi" style="font-size:22px; cursor:pointer" @click="visible = false" />
            </div>
            <div class="entry-menus-wrapper__search">
              <a-input
                v-model="keyword"
                allow-clear
                size="large"
                :placeholder="$t('layouts.menusearch')">
                <a-icon slot="prefix" type="search" />
              </a-input>
            </div>

            <div class="entry-menus-wrapper__bd" v-if="keyword">
              <entry-menus-search
                :menus="menus"
                :favorites="favorites"
                :keyword="keyword"
                :currentLang="currentLang"
                :tabActiveKey="tabActiveKey"
                @click="(key) => onChange(key, { statisticsType: 1, searchKey: keyword })"
              />
            </div>

            <div class="entry-menus-wrapper__bd" v-else>
              <menus-item
                :tabActiveKey="tabActiveKey"
                :currentLang="currentLang"
                :menu="menusLevel2"
                :active-key="tabActiveKey"
                :favorites="favorites"
                @click="(key) => onChange(key, { statisticsType: 1 })"
              />
            </div>
          </div>
        </div>
        <div class="entry-menus-silder">
          <template v-for="menu in menusLevel2.childMenus.filter(find => find.updateFlag === 1)">
            <div class="entry-menus-silder__item"
              :class="{
                'entry-menus-silder__item--active': tabActiveKey === menu.key
              }"
              :key="menu.key"
              @click="onTabChange(menu.key)">
              <span>{{menu | menuNameRender}}</span>
            </div>
          </template>
        </div>
      </div>
      <div class="entry-multi-tab__menus__mask" v-show="visible" @click="visible=false"></div>
    </div>

    <!-- 中间 - 开启标签 -->
    <main class="entry-multi-tab__wrapper">
      <div
        v-if="panes && panes.length"
        class="entry-multi-tab-item"
        style="padding: 0 10px"
        :class="{ 'entry-multi-tab-item__active': activeKey === panes[0].key }"
        @click="() => onChange(panes[0].key, { statisticsType: 1 })"
      >
        <a-icon type="home" style="font-size:14px;" />
      </div>
      <div v-if="directionFlag" class="entry-multi-tab-item entry-multi-tab-item__direction" @click="rollTo(-1)" :class="{'disabled': directionFlag === -1}">
        <a-icon type="left" />
      </div>
      <SlickList
        ref="slickListRef"
        class="entry-multi-tab-list"
        v-model="items"
        lockAxis="x"
        axis="x"
        lockToContainerEdges
        :distance="20"
        helper-class="entry-multi-tab-item__drop"
        @input="sortDropDone"
        tag="ul"
      >
        <SlickItem
          v-for="(pane, index) in items"
          :index="index"
          :key="pane.key"
          class="entry-multi-tab-item"
          :class="{ 'entry-multi-tab-item__active': activeKey === pane.key }" @click.native="() => onChange(pane.key, { statisticsType: 1 })"
          tag="li"
        >
          {{ pane | menuNameRender }}
          <a-icon type="close" style="font-size: 12px; margin-left: 4px" v-if="pane.closable" @click.stop="() => remove(pane.key)" />
        </SlickItem>
      </SlickList>
      <div v-if="directionFlag" class="entry-multi-tab-item entry-multi-tab-item__direction" @click="rollTo(1)" :class="{'disabled': directionFlag === 1}">
        <a-icon type="right" />
      </div>
    </main>
    <a-dropdown slot="tabBarExtraContent" :trigger="['click']" >
      <div class="dropdown-content">
        <a-icon type="down" />
      </div>
      <a-menu slot="overlay" @click="closeMenuClick">
        <a-menu-item key="ClosePane">{{ $t('tabs.close.current') }}</a-menu-item>
        <a-menu-item key="CloseRightPanes">{{ $t('tabs.close.right') }}</a-menu-item>
        <a-menu-item key="CloseLeftPanes">{{ $t('tabs.close.left') }}</a-menu-item>
        <a-menu-item key="CloseAllPane">{{ $t('tabs.close.all') }}</a-menu-item>
      </a-menu>
    </a-dropdown>

    <!-- 易学堂（直播/回放） -->
    <div class="entry-oguide" v-demo="'guideToLive'" style="border-right: 1px solid #E5E8EB;">
      <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 13 13" fill="none">
        <path d="M4.69043 4.52224C4.69043 4.255 4.88015 4.14503 5.11275 4.27576L8.88836 6.39733C9.12157 6.52842 9.12096 6.74135 8.88836 6.87196L5.11275 8.99354C4.87954 9.12463 4.69043 9.0143 4.69043 8.74705V4.52224Z" fill="white" stroke="#4E535C"/>
        <circle cx="6.33789" cy="6.875" r="5.625" stroke="#4E535C"/>
      </svg>
      <span style="margin-left: 5px">{{ $t('layouts.直播/回放') }}</span>
    </div>

    <!-- 操作指南 -->
    <div class="entry-oguide" v-demo="'guideTo'">
      <svg xmlns="http://www.w3.org/2000/svg" width="11" height="13" viewBox="0 0 11 13" fill="none">
        <path d="M8.20879 4.6995C8.09941 4.65738 7.98047 4.66009 7.87383 4.70629L4.16875 6.31773L2.54863 9.99987C2.49941 10.1113 2.49941 10.2376 2.54863 10.3491C2.59512 10.455 2.68125 10.5379 2.79062 10.58C2.84258 10.6004 2.8959 10.6099 2.95059 10.6099C3.01074 10.6099 3.06953 10.5977 3.12559 10.5732L6.83066 8.9618L8.45078 5.27967C8.5 5.16825 8.5 5.04189 8.45078 4.93048C8.40293 4.82314 8.3168 4.74162 8.20879 4.6995ZM6.38223 7.94004L6.74043 8.29603L6.16074 8.87213L5.80254 8.51614L3.6916 9.43464L4.61445 7.33677L4.26582 6.98894L4.84551 6.41284L5.19414 6.75932L7.30644 5.84218L6.38223 7.94004Z" fill="#4E535C"/>
        <path d="M4.84531 6.41284L4.26562 6.98894L4.61426 7.33677L5.80234 8.51614L6.16055 8.87213L6.74023 8.29603L6.38203 7.94004L5.19531 6.75932L4.84531 6.41284Z" fill="#4E535C"/>
        <path d="M8.99952 0.671875C9.27356 0.671875 9.49711 0.90771 9.5 1.19886V2.80167H10.4995C10.775 2.80167 11 3.0375 11 3.33448V3.86729H0V1.73604C0 1.14791 0.448557 0.671875 0.995192 0.671875H8.99952ZM8.50048 1.73604H1.49712C1.22163 1.7375 0.999519 1.97479 1.00096 2.26886C1.00096 2.56438 1.22308 2.80167 1.49712 2.80167H8.50048V1.73604ZM0 3.86584H11V11.5377C11 12.123 10.5514 12.5975 9.99759 12.5975H1.0024C0.737019 12.599 0.483173 12.4869 0.294231 12.2889C0.106731 12.0895 0 11.8202 0 11.5377V3.86584ZM0.999519 3.86584V11.0035C1.0024 11.2946 1.22308 11.529 1.49567 11.5319H9.50432C9.77692 11.529 9.99759 11.2946 10.0005 11.0035V3.86584H0.999519Z" fill="#4E535C"/>
        </svg>
      <span style="margin-left: 5px">{{ $t('layouts.operation.guide') }}</span>
    </div>

    <!-- 右侧 - 收藏夹 -->
    <a-popover placement="bottom">
      <div class="entry-bookmarks">
        <img class="entry-bookmarks-icon" src="@/assets/start.png">
        <span class="entry-bookmarks-text">{{ $t('layouts.bookmarks') }}</span>
        <a-icon type="caret-down" style="margin-left: 5px;" />
      </div>

      <div slot="content" class="entry-bookmarks-wrapper" v-if="favorites.length">
        <div class="entry-bookmarks-list">
          <div class="entry-bookmarks-list__item" v-for="item in favorites" :key="item.key" @click="onChange(item.key, { statisticsType: 2, searchKey: '' })">
            <img class="entry-bookmarks-list__thumb" src="@/assets/bookmark.png" alt="">
            <div class="entry-bookmarks-list__title">{{ item | menuLocalName }}</div>
          </div>
        </div>
        <!-- <div class="entry-bookmarks-btn" @click="openAll">{{ $t('layouts.openAll') }}</div> -->
        <div class="entry-bookmarks-btn" @click="visible = true">{{ $t('layouts.manageFavorites') }}</div>
      </div>
      <div slot="content" class="entry-bookmarks-wrapper" v-else>
        <div class="entry-bookmarks-list">
          <div style="color:#999;text-align:center;line-height:48px;">-- {{ $t('layouts.text.undefined') }} --</div>
        </div>
      </div>
    </a-popover>
  </section>
</template>

<script>
import { mapActions, mapMutations } from 'vuex'
import EntryMenusItem from './EntryMenusItem'
import EntryMenusSearch from './EntryMenusSearch'
import { filterPane, documentChangeUrl } from '@/store/_util/util'
import { SlickList, SlickItem } from 'vue-slicksort'

export default {
  name: 'EntryMultiTab',
  components: {
    menusItem: EntryMenusItem,
    EntryMenusSearch,
    SlickList,
    SlickItem
  },
  props: {
    favorites: {
      type: Array,
      default: () => []
    },
    menus: {
      type: Array,
      default: () => []
    },
    panes: {
      type: Array,
      default: () => []
    },
    activeKey: {
      type: String,
      default: ''
    },
    currentLang: {
      type: String,
      default: 'zh_CN'
    }
  },
  data () {
    return {
      visible: false,
      keyword: '',
      tabActiveKey: '',
      directionFlag: 0, // 箭头控制器 | 0 不可见 -1 左边不可操作 1 右边不可操作 2 均可操作
      items: []
    }
  },
  watch: {
    panes () {
      this.items = this.panes.slice(1)
    }
  },
  computed: {
    menusLevel2 () {
      const { menus, currentLang } = this.$props
      const { keyword } = this.$data
      let childMenus = []

      menus.forEach(item => {
        if (item.childMenus.length) {
          // if (item.special === 2) {
          //   item.childMenus.forEach(child => {
          //     child.childMenus.length && childMenus.push(...child.childMenus)
          //   })
          // } else {
          //   childMenus.push(...item.childMenus)
          // }
          childMenus.push(...item.childMenus)
        }
      })
      if (keyword) {
        childMenus = childMenus.filter(item => {
          // if (~(item.menuName[currentLang] || item.tab).indexOf(keyword)) return true
          const lastMenus = filterPane(item.childMenus, { lastMenu: 2 })
          const search = lastMenus.filter(menu => {
            const menuName = menu.menuName[currentLang] || menu.tab
            return ~menuName.indexOf(keyword)
          })
          return search.length
        })
      }

      return {
        key: 0,
        special: 1,
        childMenus: childMenus || []
      }
    }
  },
  methods: {
    ...mapActions({
      remove: 'entry/ClosePane'
    }),
    ...mapMutations({
      setPanes: 'entry/SET_PANES'
    }),
    onChange (activeKey, record = {}) {
      this.$emit('change', activeKey, record)
    },
    onTabChange (activeKey) {
      this.tabActiveKey = this.tabActiveKey === activeKey ? '' : activeKey

      if (this.tabActiveKey && document.querySelector(`[data-menu-key="${activeKey}"]`)) {
        const offsetTop = document.querySelector(`[data-menu-key="${activeKey}"]`).offsetTop

        document.querySelector('.entry-menus-wrapper__bd').scrollTop = offsetTop - 95
      }
    },
    // onEdit (targetKey, action) {
    //   this[action](targetKey)
    // },
    closeMenuClick ({ key }) {
      const { activeKey } = this
      // 后期需要优化，尽量减少$store直接操作
      this.$store.dispatch(`entry/${key}`, activeKey)
    },
    openAll () {
      this.favorites.forEach(item => {
        this.$store.commit('entry/ADD_PANE_BY_KEY', item.key)
      })
    },
    guideTo () {
      const { activeKey } = this
      // 判断关联文档是哪个系统，跳转对应的系统文档中心
      documentChangeUrl(this, activeKey.replace(/[^0-9]+/, ''))
    },
    guideToLive () {
      const { serviceId, systemCode } = this.$route.params
      this.$store.dispatch('entry/SetActiveAsync', {
        path: `/entry/${serviceId}/${systemCode}/sso-web#/company/helper/live-roadcast`
      })
    },
    sortDropDone (arr) {
      this.setPanes([this.panes[0], ...arr])
    },
    slickListResizeHandle ({ target }) {
      if (!target) return
      if (target.scrollWidth <= target.offsetWidth) {
        this.directionFlag = 0
      } else {
        if (target.scrollLeft === 0) return (this.directionFlag = -1)
        if (target.scrollLeft >= (target.scrollWidth - target.offsetWidth)) return (this.directionFlag = 1)
        this.directionFlag = 2
      }
    },
    rollTo (direction, step = 30) {
      const ele = this.$refs['slickListRef'].$el
      const length = ele.offsetWidth
      const scrollLeft = !direction ? 0 : ele.scrollLeft
      let count = 0
      const render = () => {
        count += step
        if (count <= length) {
          ele.scrollTo(scrollLeft + count * direction, 0)
          window.requestAnimationFrame(render)
        } else {
          this.slickListResizeHandle({ target: ele })
        }
      }
      window.requestAnimationFrame(render)
    }
  },
  mounted () {
    this.$nextTick(() => {
      const ele = this.$refs['slickListRef'].$el
      const resizeObserver = new ResizeObserver(([entry]) => {
        this.slickListResizeHandle(entry)
      })
      resizeObserver.observe(ele)
      this.$once('hook:beforeDestroy', () => {
        resizeObserver.unobserve(ele)
      })
      // 获取选中的页签位置
      const unwatch = this.$watch('activeKey', function (activeKey) {
        setTimeout(() => {
          const paneIndex = this.items.findIndex(({ key }) => key === activeKey)
          if (~paneIndex) {
            const activePaneEle = ele.children[paneIndex]
            const intersectionObserver = new IntersectionObserver(([entry]) => {
              if (entry.intersectionRatio <= 1) {
                // 延时兼容safari
                setTimeout(() => {
                  ele.scrollTo(entry.boundingClientRect.left - entry.rootBounds.left, 0)
                  this.slickListResizeHandle({ target: ele })
                })
              }
              intersectionObserver.unobserve(activePaneEle)
            }, {
              root: ele,
              threshold: 1
            })
            intersectionObserver.observe(activePaneEle)
          }
        })
        unwatch()
      })
    })
  }
}
</script>

<style lang="less" scoped>
.entry-multi-tab {
  display: flex;
  align-items: center;
  background: #fff;
  line-height: 30px;
  z-index: 55;
  border-bottom: 1px #e9e9e9 solid;

  .dropdown-content {
    padding: 0 7px;
    font-size: 14px;
  }

  &__wrapper {
    flex: 1;
    min-width: 0;
    display: flex;
    border-left: 1px #eee solid;
  }
  // 菜单滚动
  &-list {
    display: inline-flex;
    overflow: hidden;
    margin: 0;
    padding: 0;
  }
  &-item {
    position: relative;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    font-size: 12px;
    padding: 0 14px;
    border-right: 1px #eee solid;
    white-space: nowrap;
    user-select: none;
    height: 30px;
    margin: 0;
    cursor: pointer;
    .anticon  {
      &:hover {
        color: @color;
      }
    }
    &__drop {
      color: @color;
      background: #fafafa;
      z-index: 55;
    }
    &__active {
     color:#007BFC;
     font-weight: bold;
     position: sticky;
     right: 0;
     left: 0;
     background: #fff;
     z-index: 1;
      &::before {
        content: '';
        display: block;
        z-index: 2;
        position: absolute;
        bottom: 0;
        left: -1px;
        right: -1px;
        height: 2px;
        background: @color;
      }
    }
    &__direction {
      padding: 0 5px;
      &:last-child {
        border-left:  1px #eee solid;
      }
      &.disabled {
        opacity: 0.2;
      }
    }
    :deep(.anticon.anticon-close){
       visibility: hidden;
    }
    &:hover{
        :deep(.anticon.anticon-close){
         visibility: visible;
      }
    }
  }
}

.entry-multi-tab__menus {
  padding: 0 14px;
  position: relative;
}
.entry-multi-tab__menus__wrapper {
  background: #ffffff;
  box-shadow: 0px 3px 6px 0px rgba(0, 0, 0, 0.15);
  position: fixed;
  z-index: 1001;
  left: 0;
  top: 42px;
  bottom: 0;
}
.entry-multi-tab__menus__wrapper__main {
  float: left;
  width: 820px;
  height: 100%;
  overflow: hidden;
}
.entry-multi-tab__menus__mask {
  position: fixed;
  z-index: 1000;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  // background: rgba(0,0,0,0.6);
}
// 菜单主视图
.entry-menus-wrapper {
  display: flex;
  flex-direction: column;
  height: 100%;
  position: relative;
}
.entry-menus-wrapper__search {
  padding: 0 15px 8px;
  width: 600px;
}

// 菜单右侧
.entry-menus-silder {
  padding: 25px 0;
  border-left: 1px solid #eee;
  display: inline-block;
  width: 180px;
  height: 100%;
  overflow: auto;

  &::-webkit-scrollbar {
    cursor: pointer;
    width: 5px;
    height: 12px;
    background-color: #fff;
  }

  &::-webkit-scrollbar-thumb {
    background: rgba(0,0,0,.3);
    background-color: rgba(0,0,0,.3);
    -webkit-border-radius: 6px;
    -moz-border-radius: 6px;
    border-radius: 6px;
  }

  &::-webkit-scrollbar-track {
    background-color: #fff;
  }
}
.entry-menus-silder__item {
  border-left: 2px solid transparent;
  padding: 0 10px;
  color: #333;
  font-size: 14px;
  line-height: 30px;
  cursor: pointer;
}
.entry-menus-silder__item:hover,
.entry-menus-silder__item--active {
  border-left-color: #077bfc;
  background: #F6F7FA;
  color: #077bfc;
  font-weight: bold;
}

.entry-menus-wrapper__hd {
  padding: 10px 15px;
  font-size: 16px;
  line-height: 26px;
  display: flex;
  align-items: center;

  > span {
    flex: 1;
    min-width: 0;
  }
}
.entry-menus-wrapper__bd {
  flex: 1;
  min-height: 0;
  overflow: auto;

  &::-webkit-scrollbar {
    cursor: pointer;
    width: 5px;
    height: 12px;
    background-color: #fff;
  }

  &::-webkit-scrollbar-thumb {
    background: rgba(0,0,0,.3);
    background-color: rgba(0,0,0,.3);
    -webkit-border-radius: 6px;
    -moz-border-radius: 6px;
    border-radius: 6px;
  }

  &::-webkit-scrollbar-track {
    background-color: #fff;
  }
}

.entry-oguide {
  // border-left: 1px solid #eee;
  padding: 0 8px;
  display: inline-flex;
  color: #252B3A;
  font-size: 12px;
  align-items: center;
  cursor: pointer;
  &:hover {
    color: #077bfc
  }
}

.entry-bookmarks {
  border-left: 1px solid #eee;
  padding: 0 8px;
  display: inline-flex;
  color: #252B3A;
  font-size: 12px;
  align-items: center;
}
.entry-bookmarks-icon {
  margin-right: 5px;
  display: inline-block;
  width: 12px;
  vertical-align: middle;
}
.entry-bookmarks-wrapper {
  margin: -12px -16px;
}
.entry-bookmarks-list {
  width: 160px;
  max-height: 430px;
  overflow: auto;
}
.entry-bookmarks-list__item {
  padding: 5px 10px;
  display: flex;
  align-items: center;
  cursor: pointer;

  &:hover {
    background: rgb(230, 247, 255);
  }
}
.entry-bookmarks-list__thumb {
  display: inline-block;
  width: 24px;
  height: 24px;
}
.entry-bookmarks-list__title {
  flex: 1;
  min-width: 0;
  color: #252B3A;
  font-size: 12px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.entry-bookmarks-btn {
  border-top: 1px solid #eeeeee;
  color: #484848;
  font-size: 14px;
  line-height: 40px;
  text-align: center;
  cursor: pointer;

  &:hover {
    color: #1890ff;
  }

  &:active {
    background: rgba(0, 0, 0, .1);
  }
}
</style>
